import React, { Component } from "react";
import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select } from '../../../../../common/custom-form/select-filter.component';
import Translation from "../../../../../common/translation/translation.component";
import DATEPICKER_OR from "../../../../../common/custom-form/custom-date-picker.component";
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Form } from 'react-redux-form';
import { costCenterActions } from "../../../../../../store/external/finance/cost-code.reducer";
import { actions } from "react-redux-form";
import { Loading } from "../../../../../common/loading";
import "./cost-allocation-form.css";
import CustomSearchableDropdownWrapper from "../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
class CostAllocationForm extends Component {
    constructor(props) {
        super(props);

        this.ConfirmationModal = React.createRef();

        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isLoading: true
        }
    }

    componentDidMount() {
        this.fetchCostAllocationData()
    }

     fetchCostAllocationData = async () => {
    const { 
        getSelectedAuthorizer, 
        financeCostCodeForm, 
        getCostCenterAuthorizersList,
        getSelectedCurrency,
        getCostCenterCurrencyList
    } = this.props;

    let authorizerName = '';
    let currencyName = '';

    if (financeCostCodeForm?.authorizer > 0) {
        authorizerName = await getSelectedAuthorizer(financeCostCodeForm.authorizer);
    }

    await getCostCenterAuthorizersList(1, authorizerName);
  
    if (financeCostCodeForm.currency) {
        currencyName = await getSelectedCurrency(financeCostCodeForm.currency);
    }
        await getCostCenterCurrencyList(1, currencyName);


    this.setState({ isLoading: false });
};
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
    
        return translation[locale][key];
      }

    loadMoreAuthorizer = (searchString) => {
        const { costCenter, getCostCenterAuthorizersList } = this.props;

        getCostCenterAuthorizersList(costCenter.authorizerListPage + 1, searchString);
    }

    handleSearchAuthorizer = (query) => {        
        const {getCostCenterAuthorizersList } = this.props;
        getCostCenterAuthorizersList(1, query);
    }

    loadMoreCurrency = (searchString) => {
        const { costCenter, getCostCenterCurrencyList } = this.props;
        getCostCenterCurrencyList(costCenter.currenciesListPage + 1, searchString);
    }

    handleSearchCurrency = (query) => {        
        const {getCostCenterCurrencyList } = this.props;
        getCostCenterCurrencyList(1, query);
    }

    render(){

        const { costCenter, financeCostCodeForm } = this.props

       if (this.state.isLoading) {
            return <Loading />;
        }

        return(
            <Form
                method="post"
                role = "form"
                model = "financeCostCodeForm"
                >
                <div className="cost-allocation-form message-form-body">
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={'capital_cost_center'} />}
                    value={financeCostCodeForm.costCenter}
                    fieldProp='.costCenter'
                    maxLength={MAX_LENGTH.limit_100}
                    placeholder={"Enter text here..."}
                    requiredField={true}   
                />
                <div  className="span-two-columns">
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'cost_center_description'} />}
                        value={financeCostCodeForm.costCenterDescription}
                        fieldProp='.costCenterDescription'
                        maxLength={MAX_LENGTH.limit_255}
                        placeholder={"Enter text here..."}
                    />
                </div>
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={'company_code'} />}
                    value={financeCostCodeForm.companyCode}
                    fieldProp='.companyCode'
                    maxLength={MAX_LENGTH.limit_100}
                    placeholder={"Enter text here..."}
                />
                <div  className="span-two-columns">
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'company_code_description'} />}
                        value={financeCostCodeForm.companyCodeDescription}
                        fieldProp='.companyCodeDescription'
                        maxLength={MAX_LENGTH.limit_255}
                        placeholder={"Enter text here..."}
                    />                    
                </div>
                    <CustomSearchableDropdownWrapper 
                        label={this.toLocaleLanguage("authorizer")}
                        options={costCenter?.costCenterAuthorizers}
                        selected={financeCostCodeForm.authorizer}
                        onChange={()=>{}}
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='.authorizer'
                        tagName='tagName'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleSearchAuthorizer}
                        onLoadMore={(val) => this.loadMoreAuthorizer(val)}
                        isLoading={!this.props?.costCenter?.costCenterAuthorizersLoaded}
                        hasMore={costCenter?.hasMoreAuthorizers}
                    />        
               
                       
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={'profit_center'} />}
                    value={financeCostCodeForm.profitCenter}
                    fieldProp='.profitCenter'
                    maxLength={MAX_LENGTH.limit_100}
                    placeholder={"Enter text here..."}
                />
             
                    <CustomSearchableDropdownWrapper 
                    label={this.toLocaleLanguage("currency_capital")}
                    options={costCenter?.costCenterCurrencies}
                    selected={financeCostCodeForm.currency}
                    onChange={()=>{}}
                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                    fieldProp='.currency'
                    tagName='key'
                    optionLabelKey={{
                        Key: 'Key',
                        Value: 'Value'
                    }}
                    maxLength={MAX_LENGTH.limit_100}
                    onSearchChange={this.handleSearchCurrency}
                    onLoadMore={(val) => this.loadMoreCurrency(val)}
                    isLoading={!this.props?.costCenter?.costCenterCurrencyLoaded}
                    hasMore={costCenter?.hasMoreCurrencies}
                />   
                 
                <Select
                    className="form-select required"
                    label={`${this.toLocaleLanguage('status')}`}
                    value={financeCostCodeForm.status}
                    options={costCenter.costCenterDropDownList.Status}
                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                    fieldProp='.status'
                    requiredField={true}
                />
                <DATEPICKER_OR
                        dateOnly={true}
                        label={<Translation translationKey={'valid_from'} />}
                        startDate={financeCostCodeForm.validFrom}
                        selectedDate={(date) => this.props.FormChange("financeCostCodeForm.validFrom", date)}
                        placeholder={`${this.toLocaleLanguage('select_date')}`}
                        maxDate={financeCostCodeForm.validTo}
                    />
                <DATEPICKER_OR
                        dateOnly={true}
                        label={<Translation translationKey={'valid_to'} />}
                        startDate={financeCostCodeForm.validTo}
                        selectedDate={(date) => this.props.FormChange("financeCostCodeForm.validTo", date)}
                        placeholder={`${this.toLocaleLanguage('select_date')}`}
                        minDate={financeCostCodeForm.validFrom}
                    />
                </div>
            </Form>
            
        )
    }
}

export default withRouter(
    connect(
        state => {
            const { translation, 
                    costCenter
                } = state;
            const { financeCostCodeForm } = state.form;
            return {
                financeCostCodeForm
                , costCenter
                , ...translation
            };
        },
        dispatch => ({
            ...bindActionCreators(Object.assign({}, costCenterActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
        })
    )(CostAllocationForm)
);
